var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 26 24","width":"26","height":"24"}},[_c('path',{attrs:{"stroke":"#121212","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.8","d":"M2.594 20.806h20.8M4.197 8.406v12.4M21.79 8.406v12.4M11.398 12.008h3.2v3.2h-3.2zM1.797 9.606l11.2-7.2 11.2 7.2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }